import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=495fc500&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=495fc500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fc500",
  null
  
)

export default component.exports